
import { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord } from '../../actions/scrapRecords_actions';
import { connect } from 'react-redux';

import ScrapRecords from '../../components/Inventories/scrapRecords'

function mapStateToProps(state) {
    return {
        scrapRecords: state.scrapRecords.all,
        isLoading: state.scrapRecords.isLoading,
        error: state.scrapRecords.error,
        currentScrapRecord: state.scrapRecords.currentScrapRecord,
        userPermissions: state.auth.userPermissions
    };
}

export default connect(mapStateToProps, { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord })(ScrapRecords);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/scrapRecords.jsx